import { MoneyBasis } from 'modules/arena/reports/model/types';
import { cn } from 'shared/utils/cn';

const OPTIONS: { id: MoneyBasis; label: string }[] = [
  { id: 'bruto', label: 'Bruto' },
  { id: 'liquido', label: 'Líquido da arena' },
];

/** Escolhe UMA métrica por vez; título, legenda e tabela acompanham, sem misturar as duas. */
export function MoneyBasisToggle({ value, onChange }: { value: MoneyBasis; onChange: (value: MoneyBasis) => void }) {
  return (
    <div role="radiogroup" aria-label="Valor exibido" className="inline-flex rounded-lg bg-chip p-0.5 text-xs font-medium">
      {OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={value === option.id}
          onClick={() => onChange(option.id)}
          className={cn(
            'rounded-md px-3 py-1.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            value === option.id ? 'bg-surface text-ink shadow-card' : 'text-ink-secondary hover:text-ink'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
